// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6755 ? "premiumcarousel.637162dd" : chunkId) + "--" + {"6078":"7ce645f","6755":"5490ed5","9610":"ee88179"}[chunkId] + ".css";
};